import { Fragment, type ReactNode, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentStep, getSteps } from "../../../Linear/redux/selectors";

import "./LinearNavigation.less";
import { goToStep } from "~/Configurators/Linear/redux/actions";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import classNames from "classnames";
import { useRenderStepName } from "~/Configurators/common/useRenderStepName";

/**
 * Component representing the horizontal navigation between steps
 */
export const LinearStepNavigation = memo(() => {
  const currentStep = useSelector(getCurrentStep);
  const stepsList = useSelector(getSteps);

  const renderStepName = useRenderStepName();

  return (
    <div className="scha__linear-configurator__steps">
      {stepsList.map((step, index) => (
        <Fragment key={index}>
          <Step name={renderStepName(index)} index={index} activeIndex={currentStep} enabled={step.active} />
          {stepsList.length - 1 !== index && (
            <div className={"scha__linear-configurator__steps__divider"}>
              <hr />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
});

interface StepProps {
  name: ReactNode;
  index: number;
  activeIndex: number;
  enabled?: boolean;
}

const Step = (props: StepProps) => {
  const { name, index, activeIndex, enabled } = props;

  const dispatch = useDispatch();
  const clickHandler = () => {
    dispatch(goToStep(index));
  };

  const cls = classNames(
    {
      doing: index === activeIndex,
      done: index < activeIndex,
      disabled: !enabled,
    },
    "scha__linear-configurator__steps__step"
  );

  const content = enabled && index < activeIndex ? <Icon type={IconType.Pencil} /> : index + 1;

  return (
    <div className={cls} onClick={enabled ? clickHandler : undefined}>
      <div className="scha__linear-configurator__steps__step--number">{content}</div>
      <div className="scha__linear-configurator__steps__step--name">{name}</div>
    </div>
  );
};
